<template>
  <div :class="['body_show',state?'body_shows':'']" v-if="body_show">
    <div class="ceping64_main">
      <h4>测评已经完成。</h4>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { bd_ceping64_report, bd_ceping64_reset, sendPdf,getLevel} from "@/api/measurement";
import { shareCon} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { getLevel as getLevel2} from "@/api/course"
export default {
  data() {
      return {
        body_show: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: "",
          state: false,
          list: {},
          ct_img: [],
          pro_js: {}
        },
        ctime: '',
        fill_emails: false,
        mailbox: '',
        next:{}
      }
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 开启下一个任务  1测评2音频3任务4小组讨论5案例
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 15:58:09
      */
      list_link() {
        let item = this.next;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid + '&level_list_id=' + item.id+'&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+'&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id + '&level_list_id=' + item.id+'&cid=' + item.cid)
        }
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        if(q.level_list_id){
          getLevel2({
            level_list_id:this.level_list_id
          }).then((data)=>{
            this.next = data.next;
          });
        }
        let ev_obj= {};
        if(q.evaluation_id || q.evaluation_id==0){
          ev_obj['evaluation_id'] = q.evaluation_id;
        }
        bd_ceping64_report(ev_obj)
          .then((data) => {
            if (data.code == 10002) {
              let redirect_query = deepCopy(this.$route.query);
              if(redirect_query.evaluation_id) {
                delete redirect_query.evaluation_id;
              }
              this.$router.push({
                path:'/bd_ceping64',
                query: redirect_query
              });
            } else if (typeof data !== 'string') {
              this.body_show = true;
              document.title = data.headtitle;
              this.ctime = data.ctime;
              this.list = data.list;
              this.data = data;
              this.state = data.state;
              this.nickname = data.nickname;
              this.type_obj.evaluation_id = this.$route.query.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = this.$route.query.uid;
              this.type_obj.nickname = data.nickname;
              this.type_obj.path = this.$route.path;
              shareCon("ceping64", this, this.type_obj);
            } else {
              location.href = data;
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })

      },
      reset() {
        this.$dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          bd_ceping64_reset()
            .then((data) => {
              this.$router.push("/bd_ceping64")
            })
        }).catch(() => {
          // on cancel
        });
      },
      send_emails() {
        if (this.$Validator.isEmail(this.mailbox)) {
          //调用加载中
          this.$emit('loadingHandle',true,"发送中");
          let q = this.$route.query;
          let ev_obj= {
            cid: 64,
            touser: this.mailbox
          };
          if(q.evaluation_id || q.evaluation_id==0){
            ev_obj['evaluation_id'] = q.evaluation_id;
          }
          sendPdf(ev_obj)
            .then((data) => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast(data.msg);
              setTimeout(() => {
                this.fill_emails = false
              },200)
            }).catch(() => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast('报告发送可能有几分钟的延迟，请耐心等待。');
              setTimeout(() => {
                this.fill_emails = false
              },200)
        });
        } else {
          this.$toast('邮箱填写不正确！');
        }

      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
.body_show {
  padding-bottom: 185px;
  background-color: #fff;
  .ceping64_main {
    padding: 0 30px;
    h4{
      font-size: 36px;
      color: #333333;
      margin: 50px;
      font-weight: bold;
    }
  }
}



</style>
